(function (module) {
'use strict';
module
  .controller('organizationProvidersController', ['$scope', 'organizationProviders', 'organizations', 'providers',
      '$stateParams', 'progressBar', 'ngDialog',
      'uiGridConstants', 'commonDialogMessage', '$filter', '$q', 'clientSelectService', 'agencySelectService',
      'toastr', 'orgFilterService',
      'currency', 'toastFactory', 'authService',
      function ($scope, organizationProviders, organizations, providers, $stateParams, progressBar, ngDialog,
        uiGridConstants,
        commonDialogMessage, $filter, $q, clientSelectService, agencySelectService, toastr, orgFilterService,
        currency, toastFactory,
        authService) {
        //variable declaration
        const progress = progressBar.getProgressBar();
        let _addOrganizationProvidersList = [];
        let _deleteOrganizationProvidersList = [];
        let _unassignedProvidersSnapshot = [];
        let _assignedProvidersSnapshot = [];
        let _tempOrganizationProvidersList = [];

        function dialogBox(dialogMessage) {
          ngDialog.open({
            template: 'templates/partials/viewErrorMsg.html',
            className: 'ngdialog-theme-plain',
            controller: ['$scope', function ($scope) {
              $scope.errMsg = `<p>${dialogMessage}</p>`;
              $scope.errTitle = 'Organization Provider Error';
            },],
          });
        }
        // Validate that filtered organization id is defined
        function validateOrganization() {
          const organization = clientSelectService.getSelectedClient();
          return organization.id != null && Number.isInteger(organization.id);
        };
        // Watch orgFilterService for changes to getFilteredOrganization() output -- expensive, calls getFilteredOrganization many times during $digest cycle
        $scope.$watch(function () {
          return clientSelectService.getSelectedClient();
        }, function (newValue, oldValue) {
          if (newValue !== oldValue) {
            clearGrids();
            setGridData();
          }
        }, true);

        function clearGrids() {
          $scope.gridUnassignedProviders.data = [];
          $scope.gridUnassignedProviders.totalItems = 0;
          $scope.gridAssignedProviders.data = [];
          $scope.gridAssignedProviders.totalItems = 0;
          $scope.unassignedGridApi.grid.selection.selectAll = false;
          $scope.assignedGridApi.grid.selection.selectAll = false;
        };
        // Validate that filtered organization id is defined
        function validateAgencyAndClientSelection() {
          const agency = agencySelectService.getSelectedAgency();
          const client = clientSelectService.getSelectedClient();
          $scope.allowOpenBookings = false;
          if(!!client.id) {
            $scope.allowOpenBookings = client.allowOpenBookings;
          }          
          return {
            agencyValid: agency.id != null && Number.isInteger(agency.id),
            clientValid: client.id != null && Number.isInteger(client.id),
          };
        }
        // Sets both grids' data
        function setGridData() {
          const valid = validateAgencyAndClientSelection();
          if (valid.agencyValid && valid.clientValid) {
            if (validateOrganization()) {

              progress.start();
              // Organization to assign/unassign provider to/from
              const selectedClient = clientSelectService.getSelectedClient();
              const selectedClientId = selectedClient.id;
              $scope.selectedClientName = selectedClient.name;
              // All Providers
              const promiseAllProviders = providers.getProvidersByAdmin();

              // provider for filtered organization
              const promiseAssignedProviders = organizationProviders.getOrganizationProvidersByOrganizationId(selectedClientId);
              $q.all([promiseAllProviders, promiseAssignedProviders]).then(function (responses) {
                if (responses[0].data.length > 0) {
                  const assignedProvidersContext = processAssignedProviders(responses[0].data, responses[1].data);
                  const unassignedProvidersContext = processUnassignedProviders(responses[0].data, assignedProvidersContext, selectedClientId);
                  // Populate grids
                  clearGrids();
                  $scope.gridUnassignedProviders.data = unassignedProvidersContext;
                  $scope.gridUnassignedProviders.totalItems = unassignedProvidersContext.length;
                  $scope.gridAssignedProviders.data = assignedProvidersContext;
                  $scope.gridAssignedProviders.totalItems = assignedProvidersContext.length;
                  // Save snapshots of initial grid data
                  _unassignedProvidersSnapshot = $scope.gridUnassignedProviders.data.slice(0);
                  _assignedProvidersSnapshot = $scope.gridAssignedProviders.data.slice(0);
                } else {
                  toastr.warning('No content received.', 'Alert');
                }
              }, function (err) {
                dialogBox(err.statusText);
              }).finally(function () {
                progress.complete();
              });
            } else {
              $scope.selectedClientName = null;
            }
          } else if (valid.agencyValid) {
            //toastFactory.toast_info('Please select a client.');
          } else {
            //toastFactory.toast_info('Please select an agency and then client.');
          }
        };
        // Filter out assigned providers
        function processUnassignedProviders(allProvidersInfo, assignedProvidersInfo, selectedClientId) {
          if (!!allProvidersInfo && !!assignedProvidersInfo) {
            // Grab providers of selected client
            let assignedProvidersIds = _.map(assignedProvidersInfo, 'ProviderId');
            return allProvidersInfo.filter(function (provider) {
              // Select providers not assigned to selected client            
              return assignedProvidersIds.indexOf(provider.Id) < 0;
            }).map(function (provider) {
              return {
                ProviderId: provider.Id,
                Name: provider.Name,
              };
            });
          }
        };

        function processAssignedProviders(allProvidersInfo, assignedProvidersInfo) {
          if (!!allProvidersInfo && !!assignedProvidersInfo) {
            assignedProvidersInfo.map(function (assignProviderObj,index) {
              allProvidersInfo.forEach(function (allProviderObj){
                if (allProviderObj.Id === assignProviderObj.ProviderId) {
                  assignProviderObj.Name = allProviderObj.Name;
                }
              });
            });
            return assignedProvidersInfo;
          }
        };

        function setAssignedOrganizationProvidersListForGrid(DataList) {
          DataList.forEach(function(provider) {
            // Remove row from left
            $scope.gridUnassignedProviders.data.splice($scope.gridUnassignedProviders.data.indexOf(
              provider), 1);
            $scope.gridUnassignedProviders.totalItems--;
            // Push row to right
            $scope.gridAssignedProviders.data.push(provider);
            $scope.gridAssignedProviders.totalItems++;
          });
        }

        function showMessage(promises) {
          if (promises.length > 0) {
            progress.start();
            $q.all(promises).then(function(responses) {
              progress.complete();
              if ((responses.length === 2 && responses[0] && responses[1]) || (responses.length === 1 &&
                  responses[0])) {
                toastr.success('Changes were successfully made.', 'Success');
                setGridData();
              } else {
                toastr.error('An error occurred while making changes.', 'Error');
              }
            });
          } else {
            toastr.info('No changes were made.', 'Info');
          }
        }
        // addOrganizationProvider and deleteProvider should only act as purely visual functions --
        // the values sent to server will depend on diff from snapshotted data at time of action.
        $scope.addOrganizationProviders = function() {
          setAssignedOrganizationProvidersListForGrid(_addOrganizationProvidersList);
          // Clear _addOrganizationProvidersList
          _addOrganizationProvidersList.length = 0;
          // Deselect left-side selectAll checkbox
          $scope.unassignedGridApi.grid.selection.selectAll = false;
        };
        $scope.deleteOrganizationProviders = function() {
          _deleteOrganizationProvidersList.forEach(function(delOrganizationProvider) {
            // Remove row from right
            $scope.gridAssignedProviders.data.splice($scope.gridAssignedProviders.data.indexOf(
                delOrganizationProvider),
              1);
            $scope.gridAssignedProviders.totalItems--;
            // Push row to left
            $scope.gridUnassignedProviders.data.push(delOrganizationProvider);
            $scope.gridUnassignedProviders.totalItems++;
          });        
      // Clear _deleteOrganizationProvidersList
      _deleteOrganizationProvidersList.length = 0;
      // Deselect right-side selectAll checkbox
      $scope.assignedGridApi.grid.selection.selectAll = false;
    };
    // Send changes to API
    $scope.saveOrganizationProviders = function() {
      if (validateOrganization()) {
        const orgId = clientSelectService.getSelectedClient().id;
        // Check diffs against snapshots
        const toAddOrganizationProviders = _.differenceWith($scope.gridAssignedProviders.data,
            _assignedProvidersSnapshot,
            _.isEqual)
          .map(function(provider) {
            return {
              OrganizationId: orgId,
              ProviderId: provider.ProviderId,
            };
          });
        _tempOrganizationProvidersList = [];
        const toDeleteOrganizationProviders = _.differenceWith($scope.gridUnassignedProviders.data,
            _unassignedProvidersSnapshot, _.isEqual)
          .map(function(provider) {
            _tempOrganizationProvidersList.push(provider);
            return {
              Id: provider.Id,
            };
        });          
        const promiseAddOrganizationProviders = organizationProviders.addOrganizationProviders(
            toAddOrganizationProviders)
          .then(function(response) {
            return !!response;
        });
        let promises = [];
                
        if (toDeleteOrganizationProviders.length > 0) {
          const confirm = ngDialog.open({
            template: 'templates/partials/viewConfirm.html',
            className: 'ngdialog-theme-plain',
            controller: ['$scope', function ($scope) {
              $scope.strTitle = 'Unassigned Providers?';
              $scope.strMsg = 'Do you really want to unassign these providers?';
            },],
          });
          confirm.closePromise.then(function(data) {
            if (data.value === 1) {
              const promiseDelOrganizationProviders = organizationProviders.deleteOrganizationProviders(
                  toDeleteOrganizationProviders)
                .then(function(response) {
                  return !!response;
                });
              promises.push(promiseDelOrganizationProviders);
              const dialog = ngDialog.open({
                template: 'templates/partials/viewSuccessMsg.html',
                className: 'ngdialog-theme-plain',
                controller: ['$scope', function ($scope) {
                  $scope.successMsg = 'The providers has been succesfully unassigned.';
                  $scope.strTitle = 'Unassign Providers Success';
                },],
              });
              dialog.closePromise.then(function(data) {});
            }
            if (data.value === 0) {
              setAssignedOrganizationProvidersListForGrid(_tempOrganizationProvidersList);
              _tempOrganizationProvidersList.length = 0;
              $scope.assignedGridApi.grid.selection.selectAll = false;
            }
            if (toAddOrganizationProviders.length > 0) {
              promises.push(promiseAddOrganizationProviders);
            }
            showMessage(promises);
          });
        } else {
          if (toAddOrganizationProviders.length > 0) {
            promises.push(promiseAddOrganizationProviders);
          }
          showMessage(promises);
        } //else
      }
    };
    // Resync grid data with server
    $scope.reset = function() {
      clearGrids();
      setGridData();
      _addOrganizationProvidersList.length = 0;
      _deleteOrganizationProvidersList.length = 0;
      if (validateOrganization()) {
        toastr.info('Grids were reset.', 'Reset');
      }
    };
    // ui-grid below    
    const columnDefs = [{
      name: 'Name',
      displayName: 'Provider',
      visible: true,
      enableHiding: false,
      enableSorting: true,
      sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
      enableFiltering: true,
      enableColumnResizing: true,
      sort: {
        direction: uiGridConstants.ASC,
        priority: 0,
      },
    }, ];
    const gridOptions = {
      paginationPageSizes: [5, 10, 25, 50],
      enableFiltering: true,
      enableGridMenu: false,
      paginationPageSize: 25,
      useExternalPagination: false,
      useExternalSorting: false,
      enableColumnResizing: true,
      enableRowSelection: true,
      enableSelectAll: true,
      enableRowHeaderSelection: true,
      multiSelect: true,
      enableSelectionBatchEvent: true,
      columnDefs: columnDefs,
    };
    // Left grid (Unassigned Agents)
    $scope.gridUnassignedProviders = _.cloneDeep(gridOptions);
    $scope.gridUnassignedProviders.onRegisterApi = function(gridApi) {
      $scope.unassignedGridApi = gridApi;
      gridApi.selection.on.rowSelectionChanged($scope, function(row) {
        if (row.isSelected) {
          _addOrganizationProvidersList.push(row.entity);
        } else {
          _addOrganizationProvidersList.splice(_addOrganizationProvidersList.indexOf(row.entity), 1);
        }
      });
      // Handle mass selection events
      gridApi.selection.on.rowSelectionChangedBatch($scope, function(rows) {
        _addOrganizationProvidersList = gridApi.selection.getSelectedRows();
      });
    };
    // Right grid (Assigned Agents)
    $scope.gridAssignedProviders = _.cloneDeep(gridOptions);
    $scope.gridAssignedProviders.onRegisterApi = function(gridApi) {
      $scope.assignedGridApi = gridApi;
      gridApi.selection.on.rowSelectionChanged($scope, function(row) {
        if (row.isSelected) {
          _deleteOrganizationProvidersList.push(row.entity);
        } else {
          _deleteOrganizationProvidersList.splice(_deleteOrganizationProvidersList.indexOf(row.entity), 1);
        }
      });
      // Handle mass selection events
      gridApi.selection.on.rowSelectionChangedBatch($scope, function(rows) {
        _deleteOrganizationProvidersList = gridApi.selection.getSelectedRows();
      });
    };
    // End ui-grid
    setGridData();
  },
]);
})(angular.module('obex'));


// WEBPACK FOOTER //
// ./client/js/controllers/organizationProvidersController.js